import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, DatePicker, Select, message } from "antd";
import moment from "moment";
import ChronicConditionService from "../../../../Services/ChronicConditionService"
import PatientService from "../../../../Services/PatientService";

function AddChronicCondition(props) {
  const [chronicValue, setChronicValue] = useState();
  const [chronicCode, setChronicCode] = useState([]);
  const [chronicDesc, setChronicDesc] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [givenDate, setGivenDate] = useState();
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
  const formRef = useRef();

  useEffect(() => {
    fetchPatientDetails(props.selectedPatient?.patientId);
  }, [])

  const fetchPatientDetails = async (Id) => {
    const payload = {
      patientId: Id
    }
    try {
      const response = await PatientService.PatientListFilter(payload);
      setSelectedPatientDetails(response.data[0]);
    }
    catch (e) {
      console.log(e)
    }
  }

  const handleCancel = () => {
    props.onClose();
  };

  const handleDate = (date, dateString) => {
    if (dateString) {
      const constructedTime = dateString + " " + "00:00:00";
      setGivenDate(constructedTime);
    }
    else {
      setGivenDate('')
    }
  }

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handlehealthChange = (value, desc) => {
    setChronicValue(value);
    setChronicDesc(desc.description);
  };

  const ChronicCode = () => {
    let payload = {
      status: 1,
    };
    ChronicConditionService.chronicConditions(payload).then((result) => {
      setChronicCode(result.data);
    });
  };

  useEffect(() => {
    ChronicCode();
  }, []);

  const onFinish = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userObj = sessionStorage.getItem('login_result')
    const userData = userObj ? JSON.parse(userObj) : null;

    const currDate = new Date().toISOString();
    const date = currDate.split('T')[0];
    const time = currDate.split('T')[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const { pastInfo } = formRef.current.getFieldValue();
    if (!pastInfo || !givenDate) {
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }
    let payload = {
      account_Id: props.selectedPatient?.account_Id,
      clinic_Id: props.selectedPatient?.clinic_Id,
      userId: props.selectedPatient?.userId,
      createdDate: constructedTime,
      givenDate: givenDate,
      createdBy: userData?.user?.userId,
      modifiedBy: userData?.user?.userId,
      status: 1,
      patientId: props.selectedPatient?.patientId,
      chronicCode: chronicValue,
      chronicDescription: chronicDesc,
      patientName: selectedPatientDetails?.salutation + ' ' + selectedPatientDetails?.firstName + ' ' + selectedPatientDetails?.lastName,
      modifiedDate: constructedTime,
    };
    
    ChronicConditionService.AddChronicConditions(payload)
      .then((result) => {
        formRef.current.resetFields();
        props.handleLatestUpdate(result.data);
        setIsLoading(false);
        props.onClose();
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        disabled={isLoading}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Chronic Condition{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="pastInfo"
            >
              <Select
                style={{ width: "100%" }}
                onChange={handlehealthChange}
                placeholder="Select"
                value={chronicValue}
                options={chronicCode.map((ele) => ({
                  value: ele.code,
                  description: ele.description,
                  label: ele.description,
                  key: ele.value,
                }))}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item label={<span>Date<span style={{ color: "#FF000F" }}>*</span></span>} name="givenDate">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>

        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="border-brand-primaryColor bg-white border rounded-md text-brand-primaryColor text-sm px-6 py-1.5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button disabled={isLoading} onClick={onFinish} className="custom_filter rounded-md px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50">
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}

export default AddChronicCondition;
